module.exports = __webpack_public_path__ + "StagSans-Medium-Cy-Gr-Web.eot";